import { cn } from "@newxsystems/shared";
import { DaylightCardLink } from "../DaylightCardLink/DaylightCardLink";
import { DaylightMedia } from "../DaylightMedia/DaylightMedia";
import { DaylightRichText } from "../DaylightRichText/DaylightRichText";
import type { IImageContentGridBottomProps } from "./ImageContentGridBottom.props";

const columns = {
  1: "lg:grid-cols-1",
  2: "lg:grid-cols-2",
  3: "lg:grid-cols-3",
  4: "lg:grid-cols-4",
} as const;

export const ImageContentGridBottom = ({
  columnCount,
  headingAs = "h3",
  imageAspectRatio,
  items,
}: IImageContentGridBottomProps) => {
  const Heading = headingAs;
  return (
    <div
      className={cn(
        "grid grid-cols-1 border-l border-t border-border sm:grid-cols-2",
        columns[columnCount || 3],
      )}
    >
      {items.map((item, index) => (
        <DaylightCardLink
          className="group relative flex flex-col border-b border-r border-border p-6 transition-colors duration-300 hover:bg-panel"
          key={index}
          link={item.cardLink}
        >
          <span className="daylight-label mb-4 block text-northsea">
            {String(index + 1).padStart(2, "0")}
          </span>
          <Heading className="font-daylight-display text-2xl font-semibold tracking-[-0.04em] text-graphite transition-colors group-hover:text-primary">
            {item.heading}
          </Heading>
          {item.description ? (
            <DaylightRichText
              className="mt-4 max-w-[38ch] text-sm leading-relaxed text-northsea"
              content={item.description}
            />
          ) : null}
          <DaylightMedia
            aspectRatio={imageAspectRatio || "16:9"}
            className="mt-6 border-t-0"
            imageClassName="transition-transform duration-500 ease-out group-hover:scale-[1.015] motion-reduce:transition-none motion-reduce:group-hover:scale-100"
            media={item.image.image}
            sizes="(min-width: 1024px) 33vw, (min-width: 640px) 50vw, 100vw"
          />
        </DaylightCardLink>
      ))}
    </div>
  );
};

ImageContentGridBottom.displayName = "Content::ImageContentGridBottom";
